// Generated by GitHub Copilot
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ServiceWorkerGuard } from '#components/tools/service-worker-guard.tsx'
import i18n, { detectDeviceLanguage, readStoredLanguage } from '#i18n.ts'

export const Route = createFileRoute('/_public')({
  // No signed-in user carries a language setting here, so the browser's remembered choice
  // (else the device language) stands in — applied before the child loaders fetch their namespaces.
  beforeLoad: async () => {
    const language = readStoredLanguage() ?? detectDeviceLanguage()
    if (language !== i18n.language) await i18n.changeLanguage(language)
  },
  component: PublicLayout,
})

/** Pathless layout for unauthenticated public pages (e.g. share links). */
function PublicLayout() {
  return (
    <ServiceWorkerGuard>
      <Outlet />
    </ServiceWorkerGuard>
  )
}
